var exports = {
  "k": "xe533113f--beba20--container",
};

module.exports = exports;
